import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import routes from "../../../../../routing/routes";
import { Button, Grid, Typography } from "@material-ui/core";

/**
 * Renders the AuthFailure component.
 * This component handles giving feedback and redirecting after authentication failure.
 * @returns JSX element
 */
export const AuthFailure = () => {
  const { t } = useTranslation(["authCapture", "snackbars"]);
  const history = useHistory();

  return (
    <Grid container spacing={3} style={{ padding: "1rem" }}>
      <Grid item xs={12}>
        <Typography variant="h5">
          {t("authFailed.title", { ns: "authCapture" })}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography style={{ marginTop: "1.25rem" }}>
          {t("authFailed.introPart1", { ns: "authCapture" })}
          <br />
          {t("authFailed.introPart2", { ns: "authCapture" })}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ul style={{ paddingLeft: "1.25rem", marginBottom: "1.25rem" }}>
          <li>{t("authFailed.tip1", { ns: "authCapture" })}</li>
          <li>{t("authFailed.tip2", { ns: "authCapture" })}</li>
          <li>{t("authFailed.tip3", { ns: "authCapture" })}</li>
        </ul>
      </Grid>
      <Grid item xs={12}>
        <Typography>{t("authFailed.support", { ns: "authCapture" })}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push("?step=0")}
            >
              {t("authFailed.retryButton", { ns: "authCapture" })}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => history.push(routes.my_events)}
            >
              {t("authFailed.backButton", { ns: "authCapture" })}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
